import { Col, Row } from "react-bootstrap";
import "./index.scss";
import comaprisonVerfied from "../../assets/images/comparison_verified.svg";
import comparisonFailed from "../../assets/images/comparison_failed.svg";
const FieldComparison = (props) => {
  const {
    selectedData,
    field_comparison_source,
    field_comparison_destination,
    size,
    custom_styles,
    classNameOrMargin,
    label,
  } = props;
  return (
    <div>
      <div
        className={`${size} ${classNameOrMargin} bg-light border rounded-2 mx-md-0 position-relative`}
      >
        <div className="comparisonImageDiv position-absolute top-0 end-0">
          <img
            src={
              selectedData?.[field_comparison_source] ===
              selectedData?.[field_comparison_destination]
                ? comaprisonVerfied
                : comparisonFailed
            }
            className="comparisonImage"
            alt="something went wrong"
          />
        </div>
        <div className="p-2">
          <div title={`${label}`} className="document_viewer_label fs-14px">
            {label}
          </div>
          <div className="mb-0 mt-2 fw-bold fs-14px ps-10">
            {selectedData?.[field_comparison_destination]}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FieldComparison;

/*
{
  "type": "field_comparison",
  "name": "re_enter_ifsc_code",
  "label": "IFSC Code Compared",
  "size": "col-lg-6 col-md-6 col-12",
  "field_comparison_source" : "ifsc_code",
  "field_comparison_destination" : "re_enter_ifsc_code"
},
 */
